import axios from 'axios';
import loadingAnimation from '../loading-animation.vue';
import axiosError from '../axios-error.vue';

export default {
  name: 'recommendedProducts',
  components: {
    loadingAnimation,
    axiosError,
  },
  props: ['productId'],
  data() {
    return {
      loading: true,
      error: false,
      recommendedProducts: [],
      mobile: true,
      firstRefresh: true,
    };
  },
  methods: {
    // if tag exists
    tagExists(needle, haystack) {
      if (haystack.includes(needle)) {
        return true;
      }
      return false;
    },

    //Followlink
    followLink(product) {
      window.location.href = product.url;
    },
    getRecommendedProducts() {
      axios
        .get(
          `/recommendations/products.json?product_id=${this.productId}&limit=10`
        )
        .then((response) => {
          this.recommendedProducts = response.data.products;
          this.loading = false;
          let productNames = [];
          //console.log(this.recommendedProducts);

          this.recommendedProducts = this.recommendedProducts.filter(
            (product) =>
              product.type.toLowerCase() !== 'gift card' &&
              product.type.toLowerCase() !== 'insurance' &&
              product.type.toLowerCase() !== 'carbon offset' &&
              product.type.toLowerCase() !== 'donation'
          );
          // this.recommendedProducts = this.
          for (let i = 0; i < this.recommendedProducts.length; i++) {
            if (productNames.includes(this.recommendedProducts[i].title)) {
              //remove publicate products.
              //console.log('found duplicate title.');
              this.recommendedProducts.splice(i, 1);
              i--; //move index back now that we removed 1.
            } else {
              productNames.push(this.recommendedProducts[i].title);
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          //console.log(error);
        });
    },
    money(value) {
      if (!value) return '';
      value = value.toString();
      let currencySymbol = '$';
      //add the currency symbol and add dot for cents.
      return (
        currencySymbol + [value.slice(0, -2), '.', value.slice(-2)].join('')
      );
    },
  },
  mounted() {
    //get product recommendations
    this.getRecommendedProducts();
  },
};
